import { Route } from "react-router-dom";
import SalesInvoiceTemplate from "../../Template/SalesInvoiceTemplate";
import ItemNestedRoute from "../../Pages/Items/ItemNestedRoute";
import { ISilderName, ItemRoutesProps } from "./PageRoute";
import { findUserPremission } from "../../Pages/Users/Roles/UserSecurityFind";
import ResourceNotFound from "../ResourceNotFound";
import DashboardTemplate from "../../Template/DashboardTemplate";
import InventoryTabs from "../../Pages/ItemInventory/InventoryTabs";

const ItemRoutes = ({ currentClient, clientSpecificRole }: ItemRoutesProps) => {
  return (
    <>
      <Route
        key="item"
        path={`/${currentClient?.id}/item/*`}
        // path={"sales/*"}
        element={
          // <AsyncSalesInvoiceTemplate
          findUserPremission(
            [
              "Master.Item.View",
              "Master.Item.Category.View",
              "Master.Item.Unit.View",
              "Master.Item.Locations.View",
            ],
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <SalesInvoiceTemplate
              // element={<AsyncSalesNestedRoute />}
              element={<ItemNestedRoute />}
              silderName={ISilderName.Item}
              breadcrumprops={[
                {
                  item: "Item",
                  path: `/billing/clients/${currentClient?.id}/item/items`,
                },
              ]}
              menuprops={[
                {
                  showData: "Items",
                },
                {
                  showData: "Item Category",
                },
                {
                  showData: "Units",
                },
                {
                  showData: "Item Locations",
                  // path: `/billing/clients/${currentClient?.id}/master/itemlocations`,
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
      {/* Inventory */}
      <Route
        path={`${currentClient?.id}/item/items/inventory`}
        element={
          findUserPremission(
            ["Master.Item.View"],
            clientSpecificRole(),
            currentClient?.id!
          ) ? (
            <DashboardTemplate
              element={<InventoryTabs />}
              breadcrumprops={[
                {
                  item: "Item",
                  path: `/billing/clients/${currentClient?.id}/item/items`,
                },

                {
                  item: "Items",
                },
              ]}
            />
          ) : (
            <ResourceNotFound pageHeight="100%" />
          )
        }
      />
    </>
  );
};

export default ItemRoutes;
